import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const PublicTestPage = () => {
  const { companyId } = useParams();
  const [firebaseReady, setFirebaseReady] = useState(false);
  
  useEffect(() => {
    // Testar se Firebase está funcionando
    try {
      import('../../services/firebase').then((firebaseModule) => {
        setFirebaseReady(true);
      });
    } catch (error) {
      console.error('Erro ao carregar Firebase:', error);
    }
  }, [companyId]);

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-md mx-auto bg-white rounded-lg shadow p-6">
        <h1 className="text-xl font-bold mb-4">Teste de Página Pública</h1>
        
        <div className="space-y-2 text-sm">
          <p><strong>Company ID:</strong> {companyId || 'Não fornecido'}</p>
          <p><strong>URL:</strong> {window.location.href}</p>
          <p><strong>Environment:</strong> {process.env.NODE_ENV}</p>
          <p><strong>Firebase Ready:</strong> {firebaseReady ? '✅ Sim' : '❌ Não'}</p>
          <p><strong>User Agent:</strong> {navigator.userAgent}</p>
          <p><strong>Timestamp:</strong> {new Date().toISOString()}</p>
        </div>
        
        <div className="mt-6">
          <h2 className="font-semibold mb-2">Teste de Console:</h2>
          <button 
            onClick={() => {}}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Testar Console
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublicTestPage;
